import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionPowerPointProperty = (
  target: CompatibilitySlide<'powerpoint'> | VotingSlide<'powerpoint'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return target.title;
    case 'module_custom_data':
      return {
        powerpoint_url: staticContents.url,
        starting_slide_number: staticContents.startingSlideNumber ?? 1,
      };
    default:
      return undefined;
  }
};
